var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_3375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2995 3.69065L10.9768 1.36665C10.5444 0.932077 10.0301 0.587539 9.46365 0.352958C8.89722 0.118377 8.28991 -0.0015931 7.67683 -1.51518e-05H4.66683C3.7831 0.00104342 2.93587 0.352573 2.31098 0.977465C1.68608 1.60236 1.33455 2.44959 1.3335 3.33332V12.6667C1.33455 13.5504 1.68608 14.3976 2.31098 15.0225C2.93587 15.6474 3.7831 15.9989 4.66683 16H11.3335C12.2172 15.9989 13.0645 15.6474 13.6894 15.0225C14.3142 14.3976 14.6658 13.5504 14.6668 12.6667V6.98998C14.6685 6.37693 14.5485 5.76965 14.3138 5.2033C14.0791 4.63696 13.7343 4.12281 13.2995 3.69065ZM12.3568 4.63332C12.5604 4.84275 12.7355 5.07811 12.8775 5.33332H10.0002C9.82335 5.33332 9.65378 5.26308 9.52876 5.13806C9.40373 5.01303 9.3335 4.84346 9.3335 4.66665V1.78932C9.58879 1.93127 9.82435 2.10609 10.0342 2.30932L12.3568 4.63332ZM13.3335 12.6667C13.3335 13.1971 13.1228 13.7058 12.7477 14.0809C12.3726 14.4559 11.8639 14.6667 11.3335 14.6667H4.66683C4.1364 14.6667 3.62769 14.4559 3.25262 14.0809C2.87754 13.7058 2.66683 13.1971 2.66683 12.6667V3.33332C2.66683 2.80289 2.87754 2.29418 3.25262 1.9191C3.62769 1.54403 4.1364 1.33332 4.66683 1.33332H7.67683C7.78616 1.33332 7.89216 1.35465 8.00016 1.36465V4.66665C8.00016 5.19708 8.21088 5.70579 8.58595 6.08087C8.96102 6.45594 9.46973 6.66665 10.0002 6.66665H13.3022C13.3122 6.77465 13.3335 6.87998 13.3335 6.98998V12.6667Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_3375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/fileicon.8a43c37abc598b8c6efeeeff0db6f6a2.svg";
export { ForwardRef as ReactComponent };